<script lang="ts">
	import dayjs from 'dayjs';
	import { twMerge } from 'tailwind-merge';
	import { NewsletterForm } from '../../../../newsletter/components/NewsletterForm';
	import { Config } from '#lib/constants/config.js';
	import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
	import { NewsletterProvenance } from '#lib/features/newsletter/constants/mixpanel-events.js';
	import { page } from '$app/state';
	import { Txt } from '$global/components/Txt';
	import { Socials } from '$global/features/navigation/components/Socials';

	interface Props {
		class?: string;
	}

	let { ...props }: Props = $props();
</script>

<div class={twMerge('flex w-full flex-col items-start', props.class)}>
	<NewsletterForm
		provenance={NewsletterProvenance.Footer}
		label="Join our newsletter"
		isHeniNewsletter={page.data.footer.listId === Config.NewsletterListIds.News}
		listId={page.data.footer.listId}
		privacyHref={page.data.privacyPolicyLink || GlobalRoutes.PrivacyUk}
		class="'w-[100%] mb-8 max-w-[320px]"
	/>
	<Socials dataCy="footer" class="mb-4 space-x-6" />
	<div>
		<Txt variant="label3" class="text-gray-500"
			>© {dayjs().format('YYYY')} HENI. All Rights Reserved.</Txt
		>
	</div>
</div>
